"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnServFb = void 0;
const base_1 = require("./base");
/**
 * Fb Pixel
 *
 * See:
 * https://developers.facebook.com/docs/facebook-pixel/reference#standard-events
  *
 */
class AnServFb extends base_1.AnServBase {
    static isLoaded() {
        return (window.fbq !== undefined);
    }
    static sendInit(pixelId, userId, email, coupon) {
        fbq("init", pixelId);
        this.logEvent({
            cmd: "init",
            pixelId: pixelId,
        });
        return true;
    }
    static sendIdentify(pixelId, userId, email) {
        const initProps = {
            uid: userId.toString(),
            em: email
        };
        fbq("init", pixelId, initProps);
        this.logEvent({
            cmd: "init",
            pixelId: pixelId,
            initProps: initProps,
        });
        return true;
    }
    static sendPage(pixelId, tags = null) {
        fbq("trackSingle", pixelId, "PageView");
        this.logEvent({
            cmd: "trackSingle",
            eventName: "PageView",
            pixelId: pixelId,
        });
        return true;
    }
    static sendStdEvent(pixelId, eventName, eventAction) {
        const trackProps = {
            content_name: eventAction
        };
        fbq("trackSingle", pixelId, eventName, trackProps);
        this.logEvent({
            cmd: "trackSingle",
            eventName: eventName,
            trackProps: trackProps,
            pixelId: pixelId,
        });
        return true;
    }
    static sendStdEventViewContent(pixelId, contentName = null, contentType = null, contentIds = null) {
        const props = {};
        if (contentName !== null) {
            props.content_name = contentName;
        }
        if (contentType !== null) {
            props.content_type = contentType;
        }
        if (contentIds !== null) {
            props.content_ids = contentIds;
        }
        fbq("trackSingle", pixelId, "ViewContent", props);
        this.logEvent({
            cmd: "trackSingle",
            eventName: "ViewContent",
            props: props,
            pixelId: pixelId,
        });
        return true;
    }
    static sendStdEventAddPaymentInfo(pixelId) {
        fbq("trackSingle", pixelId, "AddPaymentInfo");
        this.logEvent({
            cmd: "trackSingle",
            eventName: "AddPaymentInfo",
            pixelId: pixelId,
        });
        return true;
    }
    static sendStdEventLead(pixelId, contentName) {
        const trackProps = {
            content_name: contentName
        };
        fbq("trackSingle", pixelId, "Lead", trackProps);
        this.logEvent({
            cmd: "trackSingle",
            eventName: "Lead",
            trackProps: trackProps,
            pixelId: pixelId,
        });
        return true;
    }
    static sendStdEventAddToCart(pixelId, contentName = null, contentIds = null) {
        const trackProps = {};
        if (contentName !== null) {
            trackProps.content_name = contentName;
        }
        if (contentIds !== null) {
            trackProps.content_ids = contentIds;
        }
        fbq("trackSingle", pixelId, "AddToCart", trackProps);
        this.logEvent({
            cmd: "trackSingle",
            eventName: "AddToCart",
            trackProps: trackProps,
            pixelId: pixelId,
        });
        return true;
    }
    static sendStdEventPurchaseProduct(pixelId, userId, orderId, price, coupon) {
        const trackProps = {
            user_id: userId,
            order_id: orderId,
            value: price,
            currency: "USD",
            coupon: coupon,
        };
        fbq("trackSingle", pixelId, "Purchase", trackProps);
        this.logEvent({
            cmd: "trackSingle",
            eventName: "Purchase",
            trackProps: trackProps,
            pixelId: pixelId,
        });
        return true;
    }
    static sendStdEventPurchaseSubscription(pixelId, userId, price, contentName, coupon) {
        const trackProps = {
            user_id: userId,
            value: price,
            currency: "USD",
            content_name: contentName,
            coupon: coupon,
        };
        fbq("trackSingle", pixelId, "Purchase", trackProps);
        this.logEvent({
            cmd: "trackSingle",
            eventName: "Purchase",
            trackProps: trackProps,
            pixelId: pixelId,
        });
        return true;
    }
    static sendStdEventSubscribe(pixelId, price) {
        const trackProps = {
            value: price,
            currency: "USD"
        };
        fbq("trackSingle", pixelId, "Subscribe", trackProps);
        this.logEvent({
            cmd: "trackSingle",
            eventName: "Subscribe",
            trackProps: trackProps,
            pixelId: pixelId,
        });
        return true;
    }
    static sendCustEvent(pixelId, eventName, eventProps) {
        fbq("trackSingleCustom", pixelId, eventName, eventProps);
        this.logEvent({
            cmd: "trackSingleCustom",
            eventName: eventName,
            eventProps: eventProps,
            pixelId: pixelId,
        });
        return true;
    }
}
exports.AnServFb = AnServFb;
AnServFb.serviceName = "FacebookPixel";
